import React from 'react';
import styles from './Section.module.scss';

const Section = ({ block, children }) => {
    return (
        <section className={styles.section} style={{
            background: block?.background || '#FFFFFF'
        }}>
            <div className={styles.content}>
                { children }
            </div>
        </section>
    );
};

export default Section;